import { render } from "./TrendExperimentGuide.vue?vue&type=template&id=855d4b04"
import script from "./TrendExperimentGuide.vue?vue&type=script&lang=js"
export * from "./TrendExperimentGuide.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"TrendExperimentGuide.vue"]])

export default __exports__